/* global google */
import createSimplePrivateGallery from '@PROJECT_ROOT/assets/desktop/js/search/simplePrivateGallery';
import getAdriaticStyles from '@PROJECT_ROOT/assets/shared/js/map/GoogleMapsStyles';
import MarkerClusterer from '@google/markerclusterer';

const tabsON = {
    options: {},
    init: function(config) {
        var self = this;
        self.options = config;
        self.rpLoaded = false;

        self.options.tabs.on('click', self.options.tabSelector, function() {
            var that = $(this);
            self.options.tabs.find('.active').removeClass('active');
            that.addClass('active');
            if (that.data('tab')=='rp') {
                self.options.poiPanel.hide();
                self.options.rpPanel.show();
                if (!self.rpLoaded) {
                    rPlannerON.render();
                    self.rpLoaded = true;
                }
            } else {
                self.options.rpPanel.hide();
                self.options.poiPanel.show();
            }
        });
    }
};

const poiON = {
    options: {},
    init: function(config) {
        var self = this;
        self.options = config;

        self.initMap();
        self.setMarkers();
        self.setCluster();
        self.initBeachType();

        //localStorage support
        self.ls = (typeof(Storage) !== "undefined");

        self.listenEvents();

        if (self.options.beachView) {
            $('#poiBeach').prop('checked', true).parent().addClass('active');
            self.elBeachList.slideDown(200);
            self.toggleMarkers(self.options.categoryMarkers['Beach'], true);
        } else if (!self.activateBeach()) {
            if (self.ls) {
                self.localStorageLoad();
            }
        }
    },
    initMap: function() {
        var self = this;

        self.options.objPosition = new google.maps.LatLng(
            self.options.objCoords.latitude,
            self.options.objCoords.longitude
        );

        self.options.poiMap = new google.maps.Map(self.options.canvas, {
            center: self.options.objPosition,
            zoom: 16,
            mapTypeId: google.maps.MapTypeId.HYBRID,
            mapTypeControl: true,
            panControl: false,
            zoomControl: true,
            scaleControl: true,
            streetViewControl: true,
            overviewMapControl: false,
            styles: getAdriaticStyles(),
        });
    },
    setMarkers: function() {
        var self = this;
        let clickAwayListener;

        self.options.objMarker = new google.maps.Marker({
            position: self.options.objPosition,
            map: self.options.poiMap,
            zIndex: 999,
            icon: self.options.icons['House']
        });
        google.maps.event.addListener(self.options.objMarker, 'click', function() {
            self.options.infoWindow.setContent('<div class="infoWindow">'+self.options.objInfo+'</div>');
            self.options.infoWindow.open(self.options.poiMap, this);
        });

        self.options.infoWindow = new google.maps.InfoWindow();
        self.options.categoryMarkers = {};
        self.options.beachMarkers = {
            sand: [],
            pebble: []
        };
        self.options.allMarkers = [];

        for (var key in self.options.locations) {
            self.options.categoryMarkers[key] = [];
            $.each(self.options.locations[key], function(index, location) {
                var locLatLng = new google.maps.LatLng(location.latitude, location.longitude);
                var marker = new google.maps.Marker({
                    position: locLatLng,
                    map: self.options.poiMap,
                    content: location.content,
                    zIndex: 100,
                    visible: false,
                    icon: self.options.icons[key]
                });
                self.options.categoryMarkers[key].push(marker);
                if (key === 'Beach') {
                    if (location.type === 'sand' || location.type === 'pebble') {
                        self.options.beachMarkers[location.type].push(marker);
                    }
                }
                self.options.allMarkers.push(marker);
                google.maps.event.addListener(marker, 'click', function() {
                    self.options.infoWindow.setContent('<div class="infoWindow">'+this.content+'</div>');
                    self.options.infoWindow.open(self.options.poiMap,this);

                    google.maps.event.addListenerOnce(self.options.infoWindow, 'domready', () => {
                        const $galleryContainer = $('#beachGalleryContainer');

                        if ($galleryContainer.length) {
                            setUpGallery($galleryContainer);
                        }

                        clickAwayListener = self.options.poiMap.addListener('click', () => {
                            self.options.infoWindow.close()
                            clickAwayListener.remove();
                        });
                    });
                });
            });
        }
    },
    setCluster: function() {
        var self = this;
        self.options.cluster = new MarkerClusterer(self.options.poiMap, [], {
            gridSize: 36,
            maxZoom: 14,
            styles: [ {
                url: self.options.icons['Cluster'],
                width: 47,
                height: 47,
                textColor: '#000',
                textSize: 13,
                anchor: [15]
            }, {
                url: self.options.icons['Cluster'],
                width: 47,
                height: 47,
                textColor: '#111',
                textSize: 14,
                anchor: [15]
            }, {
                url: self.options.icons['Cluster'],
                width: 47,
                height: 47,
                textColor: '#222',
                textSize: 15,
                anchor: [15]
            }]
        });
    },
    initBeachType: function() {
        var self = this;
        var countSand = self.options.beachMarkers['sand'].length,
            countPebble = self.options.beachMarkers['pebble'].length;

        if (countSand !== 0) {
            $(self.options.selectors.countSand).html(countSand);
        } else {
            $(self.options.selectors.countSand).parent().hide();
        }

        if (countPebble !== 0) {
            $(self.options.selectors.countPebble).html(countPebble);
        } else {
            $(self.options.selectors.countPebble).parent().hide();
        }

        self.elBeachList = $(self.options.selectors.beachList);
    },
    toggleMarkers: function(markers, show, skipFocus) {
        var self = this;
        var categoryBounds = new google.maps.LatLngBounds(
            self.options.objPosition,
            self.options.objPosition
        );
        if (show) {
            $.each(markers, function(index, marker) {
                marker.setVisible(true);
                categoryBounds.extend(marker.getPosition());
            });
            if (!skipFocus) {
                self.options.poiMap.fitBounds(categoryBounds);
            }
            self.options.cluster.addMarkers(markers);
        } else {
            $.each(markers, function(index, marker) {
                marker.setVisible(false);
            });
            self.options.cluster.removeMarkers(markers);
        }
    },
    listenEvents: function() {
        var self = this,
            selectors = self.options.selectors;

        $(selectors.checkList).on('change', selectors.checkbox, function() {
            var that = $(this);
            if (typeof(self.options.categoryMarkers[that.val()]) !== "undefined") {
                self.toggleMarkers(self.options.categoryMarkers[that.val()], that.prop('checked'));
                that.parent().toggleClass('active');
                if (that.val() == 'Beach' ) {
                    self.elBeachList.find('input').first().prop('checked', true);
                    self.elBeachList.slideToggle(200);
                }

                if (self.ls) {
                    var lsArray = JSON.parse(localStorage.getItem('poi'));
                    var catIndex = $.inArray(that.val(), lsArray);

                    if( catIndex == -1) {
                        lsArray.push(that.val());
                    } else {
                        lsArray.splice(catIndex, 1);
                    }
                    localStorage.setItem('poi', JSON.stringify(lsArray));
                }
            }
        });

        self.elBeachList.on('change', selectors.beachRadio, function() {
            if (this.value == 'all') {
                self.toggleMarkers(self.options.categoryMarkers['Beach'], false);
                self.toggleMarkers(self.options.categoryMarkers['Beach'], true);
            } else {
                self.toggleMarkers(self.options.categoryMarkers['Beach'], false);
                self.toggleMarkers(self.options.beachMarkers[this.value], true);
            }
        });

        $(selectors.clearLink).on('click', function() {
            $(selectors.checkbox).prop('checked', false).parent().removeClass('active');
            self.elBeachList.slideUp(200);
            $.each(self.options.allMarkers, function(index, marker) {
                marker.setVisible(false);
            });
            self.options.cluster.clearMarkers();
            if (self.ls) { localStorage.poi = '[]'; }
        });

        $(selectors.zoomActive).on('click', function() {
            var activeCategories = $(selectors.checkbox+':checked');
            if (activeCategories.length !== 0) {
                var activeCategoriesBounds = new google.maps.LatLngBounds(
                    self.options.objPosition,
                    self.options.objPosition
                );
                $.each(self.options.allMarkers, function(index, marker) {
                    if (marker.getVisible()) {
                        activeCategoriesBounds.extend(marker.getPosition());
                    }
                });
                self.options.poiMap.fitBounds(activeCategoriesBounds);
            }
        });

        $(selectors.focusLink).on('click', function() {
            self.options.poiMap.panTo(self.options.objPosition);
            self.options.poiMap.setZoom(16);
        });
    },
    localStorageLoad: function() {
        var self = this;
        if (typeof(localStorage.poi) === "undefined") { localStorage.poi = '[]'; }
        var lsArray = JSON.parse(localStorage.getItem('poi'));
        if (lsArray.length > 0 ) {
            $.each(lsArray, function(index, category) {
                $('#poi'+category).prop('checked', true).parent().addClass('active');
                if (category == 'Beach' ) {
                    self.elBeachList.slideDown(200);
                }
                if (self.options.categoryMarkers[category]) {
                    self.toggleMarkers(self.options.categoryMarkers[category], true, true);
                }
            });
        }
    },
    activateBeach: function() {
        var self = this;

        if (!self.ls || (self.ls && typeof(localStorage.poi) === "undefined") ) {
            $('#poiBeach').prop('checked', true).parent().addClass('active');
            self.elBeachList.slideDown(200);
            self.toggleMarkers(self.options.categoryMarkers['Beach'], true, true);

            if (self.ls) {
                localStorage.setItem('poi', '["Beach"]');
            }
            return true;
        }

        return false;

    }
};

function setUpGallery($galleryContainer) {
    createSimplePrivateGallery({
        source: $galleryContainer.data('gallery').map( function (image) { return { url: image['standard'] }; }),
        nextButton: $galleryContainer.find('.simpleGalleryNext')[0],
        previousButton: $galleryContainer.find('.simpleGalleryPrev')[0],
        counterElement: $galleryContainer.find('.simpleGalleryCounter')[0],
        imageElement: $galleryContainer.find('.simpleGalleryImage')[0],
    });
}

const rPlannerON = {
    options: {},
    init: function(config) {
        var self = this;
        self.options = config;
    },
    render: function() {
        var self = this;

        var rpMapData = {
            mapContainerId: self.options.mapContainerId,
            fromAddress: self.options.fromAddress,
            toAddress: self.options.toAddress,
            directionsContainerId: self.options.directionsContainerId,
            longitude: self.options.coords.longitude,
            latitude: self.options.coords.latitude,
            defaultValue: self.options.placeholder.start,
            location: self.options.location
        };

        self.googleDirections.initialize(rpMapData);
        $(self.options.searchForm).submit(function(e){
            e.preventDefault();
            self.googleDirections.initialize(rpMapData);
        });
        self.listenEvents();
    },
    listenEvents: function() {
        var self = this;

        $(self.options.fromAddress).on({
            focus: function() {
                var that = $(this);
                if(that.val() == self.options.placeholder.start) {
                    that.val('');
                }
            },
            blur: function() {
                var that = $(this);
                if(that.val() === '') {
                    that.val(self.options.placeholder.start);
                }
            }
        });
        $(self.options.toAddress).on({
            focus: function() {
                var that = $(this);
                if(that.val() == self.options.placeholder.end) {
                    that.val('');
                }
            },
            blur: function() {
                var that = $(this);
                if(that.val() === '') {
                    that.val(self.options.placeholder.end);
                }
            }
        });
    },
    googleDirections: {
        initialize: function(data) {
            document.getElementById(data.directionsContainerId).innerHTML = '';

            if (data.latitude && data.longitude)
                var point = new google.maps.LatLng(data.latitude, data.longitude);
            else
                var toAddressLocation = $(data.toAddress);

            const toAddress = point !== undefined ? point : toAddressLocation.val();

            var center = point !== undefined ? point : new google.maps.LatLng(44.713361, 16.102841);

            var fromAddress = $(data.fromAddress);

            var mapOptions = {
                center: center,
                zoom: 7,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: getAdriaticStyles(),
            };

            var map = new google.maps.Map(document.getElementById(data.mapContainerId), mapOptions);

            if (fromAddress.val() !== "" && fromAddress.val() !== data.defaultValue)
            {
                var directionsService = new google.maps.DirectionsService();
                var directionsRenderer = new google.maps.DirectionsRenderer();

                directionsRenderer.setMap(map);
                directionsRenderer.setPanel(document.getElementById(data.directionsContainerId));

                var request = {
                    origin: fromAddress.val(),
                    destination: toAddress,
                    travelMode: google.maps.DirectionsTravelMode.DRIVING
                };

                directionsService.route(request, function(result, status) {
                    if (status == google.maps.DirectionsStatus.OK) {
                        directionsRenderer.setDirections(result);
                    }
                });
            }

            if (point !== undefined && directionsRenderer === undefined) {
                var marker = new google.maps.Marker({
                    position: point,
                    map: map,
                    title: data.location,
                    icon: document.getElementById('poiIconUrls').getAttribute('data-placepin'),
                });
            }
        }
    }
};

export { tabsON, poiON, rPlannerON };
